<script setup lang="ts">
import { getRobotsDirective } from "~~/shared/utils/seo/robots";

const { markActivity, startAutoRefresh } = useAuth();
const route = useRoute();
const { locale } = useI18n();
const robotsDirective = computed(() => getRobotsDirective(route.fullPath));

useHead(() => ({
  htmlAttrs: { lang: locale.value },
  meta: robotsDirective.value
    ? [
        {
          key: "robots-policy",
          name: "robots",
          content: robotsDirective.value,
        },
        {
          key: "googlebot-policy",
          name: "googlebot",
          content: robotsDirective.value,
        },
      ]
    : [],
}));

const onActivity = () => markActivity();

onMounted(() => {
  startAutoRefresh();
  window.addEventListener("mousemove", onActivity, { passive: true });
  window.addEventListener("keydown", onActivity, { passive: true });
  window.addEventListener("click", onActivity, { passive: true });
  window.addEventListener("scroll", onActivity, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener("mousemove", onActivity);
  window.removeEventListener("keydown", onActivity);
  window.removeEventListener("click", onActivity);
  window.removeEventListener("scroll", onActivity);
});
</script>

<template>
  <div class="font-sans">
    <NuxtPage />
  </div>
</template>
